import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _defineProperty from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import path from "path";
import { schoolMap } from "@/utils/constants";
import { generateTitle } from "@/utils/i18n";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";
import { mapGetters } from "vuex";
export default {
  name: "SidebarItem",
  computed: _objectSpread({}, mapGetters(["customernum", "msgnum", "roles", "username"])),
  components: {
    Item: Item,
    AppLink: AppLink
  },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  created: function created() {
    var _this = this;
    var gyGov = process.env.NODE_ENV === 'production' && (this.username === '11011502' || this.username === '630000101' || this.username === '110115101') || (process.env.NODE_ENV === 'development' || process.env.VUE_APP_ENV === 'test') && this.username === '14072806';
    var gySchool = process.env.NODE_ENV === 'production' && !!schoolMap.find(function (item) {
      return item.username === _this.username;
    });
    this.isGy = gyGov || gySchool;
    this.isYsl = process.env.NODE_ENV === 'production' && (this.username === '110102134' || this.username === '460321101' || this.username === '430621101' || this.username === '431121101' || this.username === '430422101' || this.username === '430522101' || this.username === '440103101' || this.username === '430681101' || this.username === '431381105' || this.username === '110105264') || (process.env.NODE_ENV === 'development' || process.env.VUE_APP_ENV === 'test') && this.username === '110101253';
    this.isZz = process.env.NODE_ENV === 'production' && this.username === '410112' || (process.env.NODE_ENV === 'development' || process.env.VUE_APP_ENV === 'test') && this.username === '460400105';
    this.isEdu = sessionStorage.getItem('login-from') == 'loginedu';
  },
  data: function data() {
    this.onlyOneChild = null;
    return {
      isGy: false,
      //近视干预
      isYsl: false,
      isZz: false,
      isEdu: false
    };
  },
  methods: {
    getTitleByLoginRote: function getTitleByLoginRote(title) {
      var finalTitle = generateTitle(title);
      if (this.isEdu) {
        if (title == '学生重点常见病监测') {
          finalTitle = "健康体检数据分析";
        }
        if (title == '常见病监测') {
          finalTitle = "中小学生健康体检";
        }
        if (title == '常见病分析') {
          finalTitle = "体检数据分析";
        }
      }
      return finalTitle;
    },
    //如果是教育系统账号不展示问卷等。。。
    eduAccountNotShowSidebars: function eduAccountNotShowSidebars(item) {
      if (this.isEdu) {
        if (item.name == 'questionably') {
          return false;
        }
      }
      return true;
    },
    //安阳眼科或者其它条件不要展示数据大屏的方法
    ayykOrOthersNotShowDataVision: function ayykOrOthersNotShowDataVision(item) {
      // console.log(JSON.stringify(item))
      // if (process.env.VUE_APP_MODE === 'ayyk'||process.env.VUE_APP_MODE === 'gxlz') {
      if (process.env.VUE_APP_MODE === 'ayyk') {
        if (item.name == 'govdatavision' || item.name == 'citydatavision' || item.name == 'districtdatavision') {
          //数据大屏的路由名称
          return false;
        }
      }
      return true;
    },
    hasOneShowingChild: function hasOneShowingChild() {
      var _this2 = this;
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var showingChildren = children.filter(function (item) {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          _this2.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = _objectSpread(_objectSpread({}, parent), {}, {
          path: "",
          noShowingChildren: true
        });
        return true;
      }
      return false;
    },
    resolvePath: function resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      return path.resolve(this.basePath, routePath);
    },
    generateTitle: generateTitle
  }
};